import { CreateSiteMutationProvider } from "__legacy/queries/sites/CreateSiteMutationProvider";
import { StakeholderQueryProvider } from "__legacy/queries/stakeholders/StakeholderQueryProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { onError, onFinish, SiteForm } from "./SiteForm";

export const New: React.FC<{}> = () => {
  const { stakeholderId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <StakeholderQueryProvider variables={{ id: stakeholderId }}>
      {({ stakeholder }) => (
        <CreateSiteMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../../")}>
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`New site for ${stakeholder.companyName}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../../../")}>Back to list</Button>
                    <Button onClick={() => navigate("../../")}>Back to Stakeholder</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <SiteForm
                  action="create"
                  form={form}
                  handler={onFinish(mutate, { stakeholderId }, {})}
                  values={{}}
                  errors={errors}
                  sites={stakeholder.sites}
                />
              </Layout.Content>
            </Fragment>
          )}
        </CreateSiteMutationProvider>
      )}
    </StakeholderQueryProvider>
  );
};
